/**
 * The mark of an ephemeral branch (the icons registry's `branch-ephemeral`
 * key, and the ephemeral badge of BranchLabel.tsx): a ghost — an environment
 * that comes and goes. A generic one, its two eyes looking right.
 *
 * Drawn inline like the other colour icons (terminalIcons.tsx, components/odooIcons/webIcons.tsx):
 * a 24x24 viewBox, 1em, decorative. Its body takes the ephemeral blue of the
 * theme (`--waadoo-ephemeral`, styles.css), so it follows the light and dark
 * modes; the eyes keep fixed colours. Never `currentColor`: the pill's text colour does not reach it.
 */
export function EphemeralGhostIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      aria-hidden="true"
      focusable="false"
    >
      {/* The body: a dome, then three scallops along the hem. */}
      <path
        d="M4 21V11a8 8 0 0 1 16 0v10l-2.67-2.2L14.67 21 12 18.8 9.33 21l-2.66-2.2z"
        fill="var(--waadoo-ephemeral)"
      />
      <ellipse cx="9" cy="11" rx="2.2" ry="2.6" fill="#fff" />
      <ellipse cx="15" cy="11" rx="2.2" ry="2.6" fill="#fff" />
      <circle cx="10" cy="11.6" r="1.15" fill="#1e3a8a" />
      <circle cx="16" cy="11.6" r="1.15" fill="#1e3a8a" />
    </svg>
  );
}
